//
//
//
//
//
//
//
//
//

function getQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]).replace(/\//g, ''); return null;
}
import { findDistrict,getDistrict } from 'alias_comm_api/index'
export default {
    name: 'app',
    data() {
      return {
        showUpdate: false,
        transitionName: '',
        cityList: []
      }
    },
    computed: {

    },
    mounted(){
    },
    beforeCreate(){

    },
    created() {
      this.getAddressList()
    },
    mounted() {

    },
    methods: {
      /**
       * "name": "门头沟区",
       * "value": "110109",
       * "parent": "110100"
       * */
      initData(data){
        if(data.length){
          data.map((item,index)=>{
            if(item.name !== '国外'){
              this.cityList.push({
                name: item.name,
                value: item.id + '',
                parent: item.province_id ? item.province_id + '': item.city_id? item.city_id + '': 0
              })
            }
            if (item.children && !item.children.length) {
              this.initData([{
                name: '',
                value: '',
                city_id: item.id
              }])
            }
            if (item.children && item.children.length) {
              this.initData(item.children)
            }
          })
        }
        return this.cityList
      },
      getAddressList(){
        findDistrict().then((res)=>{
          this.cityList = []
          this.$store.commit('updateAddressList', {addressList:this.initData(res.data, this.cityList)})
        })
      },
    },
    components: {
    },
    watch: {
      '$route' (to, from) {

        // var noTranstionRouter = ['/', '/message', '/my'];
        // if(noTranstionRouter.indexOf(to.path) > -1 && noTranstionRouter.indexOf(from.path)>-1){
        //     this.transitionName = 'aaa';
        //     return;
        // }
        // const toDepth = to.path.split('/').length
        // const fromDepth = from.path.split('/').length
        // if(toDepth === fromDepth){
        //       this.transitionName = 'slide-right'
        // }else{
        //    this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left'
        // }
      }
    }
  }



// WEBPACK FOOTER //
// ./src/App.vue